/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Boards from './Boards/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import Header from './Header/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TasksFilters/Board/Content/Content/Content",
  innerRef,
  left,
  top,
  boardId
  
}) {
  let isBefore = useIsBefore()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--l-1-Z1Yf8zk': typeof left === 'number' ? `${left}px` : left,'--t-2-Z1Yf8zk': typeof top === 'number' ? `${top}px` : top,'--bc-3-Z1Yf8zk': dtColorsWhite,'--bc-4-Z1Yf8zk': dtColorsNeutral200,'--btlr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--o-9-Z1Yf8zk': isBefore ? 0 : 1,'--ty-10-Z1Yf8zk': isBefore ? "-8px" : "0px"}}
 className={`views-block dropdown-shadow ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-11-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-12-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-13-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-14-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical1}`}
>
<Header
  viewPath={`${viewPath}/Header`}
/>
<Boards
  viewPath={`${viewPath}/Boards`}
 boardId={boardId}
/>
</div>
</div>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}